import { SpotlightDocumentSchema } from "@redotech/redo-spotlight-common/spotlight-document-schema";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getSpotlight = {
  name: "getSpotlight" as const,
  input: z.object({ spotlightId: zExt.objectId() }),
  output: z.object({ spotlight: SpotlightDocumentSchema.nullable() }),
};
